<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
  @import "./style/style";
  @import "./style/public.css";
  @import "./style/PopShow.css";
</style>



// WEBPACK FOOTER //
// src/App.vue